import React from "react";
import { Box, Typography, Link } from "@mui/material";
const ACCENT = "#6d28d9";
const focusSx = { "&:focus-visible": { outline: `2px solid ${ACCENT}`, outlineOffset: "3px" } };

export default function ToastSetupGuide({ expanded = false }) {
  return (
    <Box sx={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", p: 2.5, mb: 3 }}>
      <Typography sx={{ fontWeight: 600, mb: 0.75 }}>Have your Toast credentials ready?</Typography>
      <Typography color="textSecondary" variant="body2">
        In Toast Web, go to <strong>Integrations → Toast API access → Manage credentials</strong>,
        then copy the Client ID. Use the Client Secret saved when those credentials were created.
      </Typography>
      <Box component="details" open={expanded || undefined} sx={{ mt: 2 }}>
        <Box component="summary" sx={{ color: ACCENT, fontSize: 14, fontWeight: 600, cursor: "pointer", borderRadius: "4px", ...focusSx }}>
          First time connecting? Set up API access
        </Box>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1.5 }}>
          You’ll need Toast’s <strong>8.4 Manage Integrations</strong> permission and
          Restaurant Management Suite Essentials or higher for each location.
        </Typography>
        <Box component="ol" sx={{ pl: 2.5, my: 2, listStyleType: "decimal", color: "#475569", fontSize: 14, lineHeight: 1.6, "& li + li": { mt: 1 } }}>
          <li>Choose <strong>Create new credentials → Standard API</strong> and name them <strong>Rightwork</strong>.</li>
          <li>
            Enable read access for orders, labor, employees, restaurants, menus, and configuration:
            <Box component="span" sx={{ display: "block", fontFamily: "monospace", fontSize: 12, mt: 0.5, overflowWrap: "anywhere" }}>
              orders:read, labor:read, labor.employees:read, restaurants:read, menus:read, config:read
            </Box>
            If using Rightwork inventory, also include <Box component="code">stock:read</Box>.
          </li>
          <li>Select every location you want to connect, apply your selection, and confirm. If a location is missing or locked, check its subscription and your 8.4 permission there. After connecting, review and link or import the locations in Rightwork.</li>
          <li>Save the Client Secret when it appears, then paste both credentials below.</li>
        </Box>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 1.5 }}>
          Rightwork handles access tokens automatically. Only the Client ID and Client Secret are needed here.
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
          <Link href="https://doc.toasttab.com/doc/devguide/devApiAccessCredentials.html" target="_blank" rel="noopener noreferrer" variant="body2" sx={{ color: ACCENT, ...focusSx }}>
            Toast setup guide ↗
          </Link>
          <Link href="https://doc.toasttab.com/doc/devguide/devApiAccessScopes.html" target="_blank" rel="noopener noreferrer" variant="body2" sx={{ color: ACCENT, ...focusSx }}>
            API scope reference ↗
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

